import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

import styles from "./AtomButtonLabel.module.scss"

export type Props = ComponentPropsWithoutRef<"label">

// TODO the clickable area for this should probably be bigger
// renders a rectangular <label />
export const AtomButtonLabel = forwardRef<HTMLLabelElement, Props>(
  function AtomButtonLabel(props: Props, propRef: Ref<HTMLLabelElement>) {
    const className = classNames(
      props.className,
      styles.atomButtonLabel,
    )

    return (
      <label
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role="button"
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        {...props}
        htmlFor={props.htmlFor}
        ref={propRef}
        className={className}
      />
    )
  },
)
